import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { Tooltip, TooltipTrigger, TooltipContent } from 'components/Display/Tooltip/Tooltip';
import { useTranslation } from 'react-i18next';
import { formatDayAndTime } from 'support/helpers/dateTime/dateTime';
import { MessageV2DTO } from 'support/types';

export const LastEditBy = ({ latestUpdate }: { latestUpdate: Required<MessageV2DTO>['latest_user_update'] }) => {
  const { t } = useTranslation();
  const lastUpdateAt = latestUpdate.created_at;
  const lastUpdateBy = latestUpdate.caused_by;
  const updatedByAdmin = lastUpdateBy && 'isAdmin' in lastUpdateBy && lastUpdateBy.isAdmin;

  if (!lastUpdateAt || !lastUpdateBy) {
    return null;
  }
  const tooltipContent = updatedByAdmin
    ? t('webedi:sidebar.properties.editInformation.editedAt.tooltip.procuros')
    : t('webedi:sidebar.properties.editInformation.editedAt.tooltip.partner', {
        userName: lastUpdateBy.name,
        partnerName: lastUpdateBy.partner?.name ?? '',
      });
  return (
    <span className="flex items-center gap-0.5">
      {formatDayAndTime(lastUpdateAt)}
      <Tooltip>
        <TooltipTrigger>
          <InformationCircleIcon className="ml-1 size-4 text-gray-400 hover:text-procuros-green-500" />
        </TooltipTrigger>
        <TooltipContent>{tooltipContent}</TooltipContent>
      </Tooltip>
    </span>
  );
};
